const BASE_URL: string = "http://localhost:3000";
const ERROR_PAGE: string = "/error";
const LANDING_PAGE: string = "/";
const HOME_PAGE: string = "/home";
const RESULTS_PAGE: string = "/search";
const AUTHENTICATE_PAGE: string = "/Authenticate";
const LOGIN_PAGE: string = "/Authenticate?mode=login";
const SIGNUP_PAGE: string = "/Authenticate?mode=signup";
const TICKET_DETAILS_PAGE = "/title";
const HISTORY_PAGE = "/history";
const ADMIN_PAGE = "/admin/titles";
const REPORT_PAGE = "/admin/report";
const CATERGORY_PAGE = "/home/category";
export {
  BASE_URL,
  ERROR_PAGE,
  LANDING_PAGE,
  HOME_PAGE,
  RESULTS_PAGE,
  HISTORY_PAGE,
  AUTHENTICATE_PAGE,
  LOGIN_PAGE,
  SIGNUP_PAGE,
  TICKET_DETAILS_PAGE,
  ADMIN_PAGE,
  REPORT_PAGE,
  CATERGORY_PAGE,
};
